import { useTranslation } from "@/i18n/client";
import { DateInputProps } from "@mantine/dates";
import { InputTooltip } from "@/components/InputTooltip";
import DateInput from "@/components/DateInput";

export const FVEDate = (props: DateInputProps) => {
  const { t } = useTranslation(["supplyPoint", "hints"]);

  return (
    <InputTooltip
      tooltipProps={{
        label: t("hints:supplyPoint.bundleServicesFVEDate"),
      }}>
      <DateInput label={t("supplyPoint:fveData.fveDate")} clearable={true} {...props} maxDate={new Date()} />
    </InputTooltip>
  );
};
